export const localization = {
    enquiriesTitle: 'Inquiries',
    enquiriesUrl: 'inquiries',
    enquiryTitle: 'Inquiry',
    locale: 'en-US',
};
